import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MFA_OAUTH_URL,
  MULTI_FACTOR_EndpointKey
} from '../../../../constants/multi-factor-authentication/multi-factor-authentication-constant';
import { ContinueAuthentication } from '../../../../models/multi-factor-authentication';
import { HttpHeadersPayload, ReplaceItem } from '../../../../models/utils';
import { ApiBuilder, AppConfigService, handleError } from '../../../utils';
import { LoginRememberMeUtilsService } from '../../../../utils/login';
import { OauthAEMConfig } from '../../../../models/login';
import { HttpRequestMethods, IDP_APP } from '../../../../constants/utils';

@Injectable({
  providedIn: 'root'
})
export class ContinueAuthenticationService {
  continueAuthenticationHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.continueAuthentication+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: LoginRememberMeUtilsService
  ) {}

  continueAuthentication = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<ContinueAuthentication> => {
    const getContinueAuthenticationUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const continueAuthenticationUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getContinueAuthenticationUrl
      }
    ];

    return new ApiBuilder<undefined, ContinueAuthentication>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(MULTI_FACTOR_EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(continueAuthenticationUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.continueAuthenticationHeader)
      .errorHandler(this._errorHandler)
      .library('CONTINUE_AUTHENTICATION_SERVICE')
      .withCredentials(true)
      .create();
  };
}
